module.exports = __webpack_public_path__ + "872f16f4ebb6baa27204768e85bb2190.fbx";